import { render, staticRenderFns } from "./FacePop.vue?vue&type=template&id=b1b1d1ee&"
import script from "./FacePop.vue?vue&type=script&lang=js&"
export * from "./FacePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports